import { useLayout as useLayoutBase } from '../../components/context/layout';

const useLayout = () => useLayoutBase() || {};

export default useLayout;
